module.exports = __webpack_public_path__ + "media/images/site-section/icons/calendar-623ec7e0ffab106f324adc86a2ae8032.svg";